import React from 'react';
import Chunk from 'components/Chunk';

const loadDashboardContainer = () => import('./containers' /* webpackChunkName: "dashboard" */);

const Dashboard = () => <Chunk load={loadDashboardContainer} />;

export default Dashboard;
